export const CONNECTION_TYPES = {
  none: 'pages.sco-organization-participants.connection-types.none',
  email: 'pages.sco-organization-participants.connection-types.email',
  identifiant: 'pages.sco-organization-participants.connection-types.identifiant',
  mediacentre: 'pages.sco-organization-participants.connection-types.mediacentre',
  without_mediacentre: 'pages.sco-organization-participants.connection-types.without-mediacentre',
};
